import React from "react";
import CustomPage from "../../lib/Pages/Customizable";

export default function NoMatch() {
  return <CustomPage slug={'404-2'} />;
}
